import { ConfigProvider } from "antd";
import { AdminAgentsActs } from "./Acts/AdminAgentsActs";
import classes from "./AdminAgentsDocuments.module.css";
import { AdminAgentsContracts } from "./Contracts/AdminAgentContracts";

export const AdminAgentDocuments = () => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Select: {
            controlItemBgHover: "rgba(217, 229, 255, 1)",
          },
        },
      }}
    >
      <div className={classes.container}>
        <AdminAgentsContracts />
        <AdminAgentsActs />
      </div>
    </ConfigProvider>
  );
};
